/**
 * 示範卡共用的打字節奏工具 — dictation-demo-machine(腳本示範)與
 * live-demo-player(真錄音結果)共用同一套逐字輸出與計時器管理,
 * 避免兩邊各維護一份相同的 tick 邏輯。
 *
 * 節奏同 prototype 的 typeInto:第 k 個字在 k*speed 出現,
 * 完成 callback 在最後一個字後再一個 tick 觸發。
 */

export interface TimerPool {
  later: (fn: () => void, ms: number) => void
  clear: () => void
}

/** 集中管理 setTimeout,dispose 時一次清掉。 */
export function createTimerPool(): TimerPool {
  let timers: ReturnType<typeof setTimeout>[] = []
  return {
    later(fn, ms) {
      timers.push(setTimeout(fn, ms))
    },
    clear() {
      for (const timer of timers) clearTimeout(timer)
      timers = []
    },
  }
}

export function typeText(
  pool: TimerPool,
  text: string,
  speed: number,
  onTick: (typed: string) => void,
  done: () => void
) {
  let index = 0
  const tick = () => {
    if (index <= text.length) {
      onTick(text.slice(0, index))
      index++
      pool.later(tick, speed)
    } else {
      done()
    }
  }
  tick()
}
